import Swiper from 'swiper'
import { Autoplay, Navigation } from 'swiper/modules'

export function initializeSlider(slider) {
  if (!(slider instanceof Element)) {
    return
  }

  const sliderWrapper = slider.querySelector('.swiper-wrapper')

  if (!(sliderWrapper instanceof Element)) {
    return
  }

  const slides = sliderWrapper.querySelectorAll('.swiper-slide')
  const slideCount = slides.length

  if (slideCount === 0) {
    return
  }

  const shouldLoop = slideCount > 1

  const swiper = new Swiper(slider, {
    loop: shouldLoop,
    autoplay: false,
    speed: 500,
    spaceBetween: 14,
    centeredSlides: true,
    slidesPerView: 1,
    modules: [Autoplay, Navigation],
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    breakpoints: {
      768: {
        spaceBetween: 0,
        slidesPerView: 1
      }
    }
  })
}